import * as React from "react";
import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableFooter from "@mui/material/TableFooter";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import { Button, Grid, TableHead } from "@mui/material";
import { useState, useEffect, useContext } from "react";
import axios from "axios";
import { useNavigate, createSearchParams } from "react-router-dom";
import BASE_URL from "../../../constants/baseUrls";
import { convertToJalali } from "../../../utils/date";
import cookie from "js-cookie";
import { ToastContainer, toast } from "react-toastify";
import { LocaleContext } from "../../../routing/LangRouter";
import BaseSelect from "../../../components/common/base-select/base-select";

//styles
import "./locations-managment.scss";

function TablePaginationActions(props) {
    const { locale, setLocale } = useContext(LocaleContext);
    const navigate = useNavigate();

    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = event => {
        onPageChange(event, 0);
    };

    const handleBackButtonClick = event => {
        onPageChange(event, page - 1);
    };

    const handleNextButtonClick = event => {
        onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = event => {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
        <Box sx={{ flexShrink: 0, ml: 2.5 }}>
            <IconButton onClick={handleFirstPageButtonClick} disabled={page === 0} aria-label="first page">
                {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
            </IconButton>
            <IconButton onClick={handleBackButtonClick} disabled={page === 0} aria-label="previous page">
                {theme.direction === "rtl" ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            </IconButton>
            <IconButton onClick={handleNextButtonClick} disabled={page >= Math.ceil(count / rowsPerPage) - 1} aria-label="next page">
                {theme.direction === "rtl" ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </IconButton>
            <IconButton onClick={handleLastPageButtonClick} disabled={page >= Math.ceil(count / rowsPerPage) - 1} aria-label="last page">
                {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
            </IconButton>
        </Box>
    );
}

TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
};

// function createData(name, calories, fat) {
//     return { name, calories, fat };
// }

// const rows = [
//     createData('Cupcake', 305, 3.7),
//     createData('Donut', 452, 25.0),
//     createData('Eclair', 262, 16.0),
//     createData('Frozen yoghurt', 159, 6.0),
//     createData('Gingerbread', 356, 16.0),
//     createData('Honeycomb', 408, 3.2),
//     createData('Ice cream sandwich', 237, 9.0),
//     createData('Jelly Bean', 375, 0.0),
//     createData('KitKat', 518, 26.0),
//     createData('Lollipop', 392, 0.2),
//     createData('Marshmallow', 318, 0),
//     createData('Nougat', 360, 19.0),
//     createData('Oreo', 437, 18.0),
// ].sort((a, b) => (a.calories < b.calories ? -1 : 1));

export default function CustomPaginationActionsTable() {
    const navigate = useNavigate();
    const accessToken = localStorage.getItem("accessToken");
    const { locale, setLocale } = useContext(LocaleContext);

    //filter
    const [cityList, setCityList] = useState([]);
    const [selectedCity, setSelectedCity] = useState(null);

    const getCityList = async () => {
        const response = await axios.get(`${BASE_URL}/basic/cities/`, {
            params: {
                country: "",
                province: "",
                limit: "3000",
            },
        });
        setCityList(response.data.results);
    };

    useEffect(() => {
        getCityList();
    }, []);

    useEffect(() => {
        cityList.map(city => {
            Object.keys(city).forEach(keyItem => {
                if (keyItem === "id") {
                    city["value"] = city[keyItem];
                }
                if (keyItem === "name") {
                    city["label"] = city[keyItem];
                }
            });
            return city;
        });

        cityList?.map(city => {
            city.color = "#1E1E1E";
            return city;
        });
    }, [cityList]);

    //get category
    const [categoryList, setCategoryList] = useState();
    const [selectedCategory, setSelectedCategory] = useState();
    const getCategoryList = async () => {
        const response = await axios.get(`${BASE_URL}/location/category/list/`);
        setCategoryList(response.data.results);
    };
    useEffect(() => {
        getCategoryList();
    }, []);
    useEffect(() => {
        categoryList?.map(category => {
            Object.keys(category).forEach(keyItem => {
                if (keyItem === "id") {
                    category["value"] = category[keyItem];
                }
                if (keyItem === "persian_name") {
                    category["label"] = category[keyItem];
                }
            });
            return category;
        });

        categoryList?.map(category => {
            category.color = "#1E1E1E";
            return category;
        });
    }, [categoryList]);

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(100);

    //request get location list
    const [locationList, setLocationList] = useState(null);
    const getLocationList = async (limit, offset) => {
        const response = await axios.get(`${BASE_URL}/g5znsh6vtyic3w5/location/list/`, {
            params: {
                country: "",
                province: "",
                city: selectedCity ? selectedCity.id : "",
                category: selectedCategory ? selectedCategory.id : "",
                limit,
                offset,
            },
            headers: {
                Authorization: `Bearer ${accessToken}`,
                "Content-Type": "application/json",
            },
        });
        setLocationList(response.data);
    };
    useEffect(() => {
        getLocationList(rowsPerPage, page * rowsPerPage);
    }, [selectedCity, selectedCategory, rowsPerPage, page]);

    //redirect to location add page
    const goToLocationAddPage = () => {
        navigate(`/${locale}/admin-panel/location-add`);
    };

    //redirect to edit page
    const handleEditLocationPage = id => {
        // const response = await axios.get(`${BASE_URL}/g5znsh6vtyic3w5/location/info/`, {
        //     params: {
        //         pk: id,
        //         action: 'viewLocation'
        //     },
        //     headers: {
        //         'Authorization': `Bearer ${accessToken}`
        //     },
        // })
        // setLocationInformation(response.data)
        // setIsEditing(true)
        // setShowForm(!showForm);
        // navigate(`/${locale}/admin-panel/location-add')
        const params = { id: id, isEditing: true };
        navigate({
            pathname: `/${locale}/admin-panel/location-add`,
            search: `?${createSearchParams(params)}`,
        });
    };

    //show form location point
    const handleLocationPointPage = (id, name) => {
        const params = { id: id, name: name };
        navigate({
            pathname: `/${locale}/admin-panel/location-point`,
            search: `?${createSearchParams(params)}`,
        });
    };

    //active or deactive location
    const handleَActiveChange = async (id, active) => {
        if (active) {
            const response = await axios.get(`${BASE_URL}/g5znsh6vtyic3w5/location/info/`, {
                params: {
                    action: "deactivateLocation",
                    pk: id,
                },
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            try {
                toast.success(response.data.message, { toastId: "custom-id-yes" });
            } catch (error) {
                toast.error(response.data.message, { toastId: "custom-id-yes" });
            }
        } else {
            const response = await axios.get(`${BASE_URL}/g5znsh6vtyic3w5/location/info/`, {
                params: {
                    action: "activateLocation",
                    pk: id,
                },
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            try {
                toast.success(response.data.message, { toastId: "custom-id-yes" });
            } catch (error) {
                toast.error(response.data.message, { toastId: "custom-id-yes" });
            }
        }
        getLocationList(rowsPerPage, page * rowsPerPage);
    };

    // Avoid a layout jump when reaching the last page with empty rows.
    const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - locationList?.count) : 0;

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
        getLocationList(rowsPerPage, newPage * rowsPerPage);
    };

    const handleChangeRowsPerPage = event => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    return (
        <Grid container rowGap={3}>
            <ToastContainer rtl={true} theme="colored"></ToastContainer>
            <Button variant="contained" color="success" onClick={goToLocationAddPage}>
                اضافه کردن لوکیشن
            </Button>
            <Grid container item xs={3} justifyContent="space-between" alignItems="center" px={2}>
                {/* <Grid item xs={4}><label className="location-add__text-field">شهر</label></Grid> */}
                <BaseSelect
                    value={selectedCity}
                    setValue={setSelectedCity}
                    placeholder="انتخاب شهر"
                    isMulti={false}
                    options={cityList}
                    search={true}
                    dropdownIndicator={true}
                ></BaseSelect>
            </Grid>
            <Grid container item xs={3} justifyContent="space-between" alignItems="center" px={2}>
                {/* <Grid item xs={4}><label className="location-add__text-field">دسته بندی</label></Grid> */}
                <BaseSelect
                    value={selectedCategory}
                    setValue={setSelectedCategory}
                    placeholder="دسته بندی"
                    isMulti={false}
                    options={categoryList}
                    search={true}
                    dropdownIndicator={true}
                ></BaseSelect>
            </Grid>
            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 500 }} aria-label="custom pagination table">
                    <TableHead>
                        <TableRow>
                            <TableCell align="center">id</TableCell>
                            <TableCell align="center">نام لوکیشن</TableCell>
                            <TableCell align="center">شهر</TableCell>
                            <TableCell align="center">ثبت کننده</TableCell>
                            <TableCell align="center">تاریخ آخرین ویرایش</TableCell>
                            <TableCell align="center">دسته بندی</TableCell>
                            <TableCell align="center"></TableCell>
                            <TableCell align="center"></TableCell>
                            <TableCell align="center"></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {locationList?.results.length
                            ? // (rowsPerPage > 0
                              //     ? locationList?.results?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                              //     : locationList?.results
                              // )
                              locationList?.results.map(locationItem => (
                                  <TableRow key={locationItem.id}>
                                      <TableCell component="th" scope="row" align="center">
                                          {locationItem.id}
                                      </TableCell>
                                      <TableCell align="center">{locationItem.name}</TableCell>
                                      <TableCell align="center">{locationItem.address.split("،")[2]}</TableCell>
                                      <TableCell align="center">{locationItem.creator.first_name + " " + locationItem.creator.last_name}</TableCell>
                                      <TableCell align="center">{convertToJalali(locationItem.last_modified)}</TableCell>
                                      <TableCell align="center">{locationItem.category.persian_name}</TableCell>
                                      <TableCell align="center">
                                          <Button variant="outlined" color="success" onClick={() => handleEditLocationPage(locationItem.id)}>
                                              ویرایش
                                          </Button>
                                      </TableCell>
                                      <TableCell align="center">
                                          <Button
                                              variant="outlined"
                                              color="error"
                                              onClick={() => handleَActiveChange(locationItem.id, locationItem.is_active)}
                                          >
                                              {locationItem.is_active ? "فعال" : "غیرفعال"}
                                          </Button>
                                      </TableCell>
                                      <TableCell align="center">
                                          <Button
                                              variant="outlined"
                                              color="secondary"
                                              onClick={() => handleLocationPointPage(locationItem.id, locationItem.name)}
                                          >
                                              امتیازدهی
                                          </Button>
                                      </TableCell>
                                  </TableRow>
                              ))
                            : ""}

                        {emptyRows > 0 && (
                            <TableRow style={{ height: 53 * emptyRows }}>
                                <TableCell colSpan={6} />
                            </TableRow>
                        )}
                    </TableBody>
                    <TableFooter>
                        <TableRow>
                            <TablePagination
                                rowsPerPageOptions={[5, 10, 25, 100, { label: "All", value: 3000 }]}
                                colSpan={3}
                                count={locationList?.count}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                SelectProps={{
                                    inputProps: {
                                        "aria-label": "rows per page",
                                    },
                                    native: true,
                                }}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                                ActionsComponent={TablePaginationActions}
                                dir="ltr"
                            />
                        </TableRow>
                    </TableFooter>
                </Table>
            </TableContainer>
        </Grid>
    );
}
